var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B82655;}\n\t.st1{fill:#F5DCCE;}\n\t.st2{fill:#DFAA94;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.42,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.12,149.93,60.73,184.22,103.42,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.49,72.9c-3.7-4.25-7.89-7.02-12.18-7.52c-14.09-1.64-32.86,20.59-35.59,44.1 c-0.28,2.44-0.35,4.78-0.31,7.05c0.42,19.58,12.54,32.45,26.01,34.02c15.03,1.75,31.69-10.57,34.42-34.08 C134.74,100.11,128.94,82.61,120.49,72.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.49,72.9c6.26,9.66,10.17,24.08,8.59,37.69c-2.62,22.57-18.39,34.41-32.6,32.76 c-11.37-1.32-21.73-11.3-24.06-26.81c0.42,19.58,12.54,32.45,26.01,34.02c15.03,1.75,31.69-10.57,34.42-34.08 C134.74,100.11,128.94,82.61,120.49,72.9"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 112.02,
    cy: 83.94,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 110.04,
    cy: 72.46,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 118.33,
    cy: 87.57,
    r: 1.16
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.38,144.55l6.54-69.13c0.14-1.44-0.93-2.61-2.37-2.61h-16.14v78.25h4.81 C127.83,151.07,131.04,148.15,131.38,144.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggs);
export default __webpack_public_path__ + "static/media/Eggs.231d2d2def18675ae78e078821f1e82b.svg";
export { ForwardRef as ReactComponent };